import React from 'react';
import { FiltersSkinType } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import { TabItemType } from 'src/domains/sportsbook/webview/components/raceCard/tabs/Tabs.type';

export interface TabsItemPropsType {
    item: TabItemType;
    skin?: FiltersSkinType;
}

export class TabsItemState {
    public constructor(private readonly props: TabsItemPropsType) {}

    public setActive = (e: React.SyntheticEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.item.labelDisabled) {
            return;
        }

        this.props.item.setActive();
    };
}
